/**
 * @generated SignedSource<<ac34e7e96545bbf7f456cd3d36ec98b4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ScreenDeviceStatus = "ACTIVE" | "INACTIVE" | "REGISTERED";
export type StorecastScreenAdminDeregisterDeviceMutation$variables = {
  id: string;
};
export type StorecastScreenAdminDeregisterDeviceMutation$data = {
  readonly storecast: {
    readonly deregisterScreen: {
      readonly id: string;
      readonly status: ScreenDeviceStatus;
    };
  };
};
export type StorecastScreenAdminDeregisterDeviceMutation = {
  response: StorecastScreenAdminDeregisterDeviceMutation$data;
  variables: StorecastScreenAdminDeregisterDeviceMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "StorecastMutation",
    "kind": "LinkedField",
    "name": "storecast",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "screenId",
            "variableName": "id"
          }
        ],
        "concreteType": "StorecastScreen",
        "kind": "LinkedField",
        "name": "deregisterScreen",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "StorecastScreenAdminDeregisterDeviceMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "StorecastScreenAdminDeregisterDeviceMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "a48e9bb8dc850a53bdbaf4d1d7b117a4",
    "id": null,
    "metadata": {},
    "name": "StorecastScreenAdminDeregisterDeviceMutation",
    "operationKind": "mutation",
    "text": "mutation StorecastScreenAdminDeregisterDeviceMutation(\n  $id: ID!\n) {\n  storecast {\n    deregisterScreen(screenId: $id) {\n      id\n      status\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "58327b8d4d83512258e16d8b75140cd3";

export default node;
